import { useTranslations } from "next-intl";
import type { ProfileType } from "@/lib/types";
import { SelectableCard } from "../SelectableCard";
import { ManIcon, WomanIcon, CoupleIcon } from "../icons";

const OPTIONS: {
  type: ProfileType;
  subtitleKey: "manSubtitle" | "womanSubtitle" | "coupleSubtitle";
  icon: React.ReactNode;
}[] = [
  { type: "male", subtitleKey: "manSubtitle", icon: <ManIcon /> },
  { type: "female", subtitleKey: "womanSubtitle", icon: <WomanIcon /> },
  { type: "couple", subtitleKey: "coupleSubtitle", icon: <CoupleIcon /> },
];

export function AccountTypeStep({
  value,
  onChange,
}: {
  value: ProfileType | null;
  onChange: (type: ProfileType) => void;
}) {
  const t = useTranslations("join.accountType");
  const tTypes = useTranslations("common.profileTypes");
  return (
    <div>
      <h1 className="font-display text-2xl font-semibold text-white sm:text-3xl">
        {t("title")}
      </h1>
      <p className="mt-2 text-sm text-white/55">
        {t("subtitle")}
      </p>

      <div className="mt-6 grid gap-3 sm:grid-cols-3">
        {OPTIONS.map((o) => (
          <SelectableCard
            key={o.type}
            selected={value === o.type}
            onSelect={() => onChange(o.type)}
            title={tTypes(o.type)}
            subtitle={t(o.subtitleKey)}
            icon={o.icon}
          />
        ))}
      </div>
    </div>
  );
}
